import { render, staticRenderFns } from "./storeOrderDetail.vue?vue&type=template&id=133dc94e&scoped=true&"
import script from "./storeOrderDetail.vue?vue&type=script&lang=js&"
export * from "./storeOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./storeOrderDetail.vue?vue&type=style&index=0&id=133dc94e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133dc94e",
  null
  
)

export default component.exports